import { render, staticRenderFns } from "./add-ki.vue?vue&type=template&id=3510feab&"
import script from "./add-ki.vue?vue&type=script&lang=js&"
export * from "./add-ki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports